import TYPES from '@/types';

// Application
import SignOutService from '@/modules/authentication/application/services/sign-out-service';

// Domain
import Inject from '@/modules/shared/domain/dependency_injection/inject';
import { MessageNotifier } from '@/modules/shared/domain/notifiers/message_notifier';

export default class ModalIdentityVerificationWasCompletedViewModel {
  @Inject(TYPES.NOTIFIER)
  private readonly notifier!: MessageNotifier;

  is_btn_loading = false;

  logout = async () => {
    try {
      this.is_btn_loading = true;
      await new SignOutService().logout();
    } catch {
      this.notifier.showErrorNotification('Ocurrió un error al cerrar sesión, favor de recargar la página');
    } finally {
      this.is_btn_loading = false;
    }
  }
}
